/** t622u: the caller's own scheduled messages (react-query). Re-read every 30 s and on focus, like the worker's cadence. */
import { useQuery } from '@tanstack/react-query';
import type { ScheduledMessage } from '@tradeoutlet/shared';
import { api } from '@/lib/api';
import { queryClient } from '@/lib/queryClient';

export const scheduledKeys = {
  all: ['scheduled-messages'] as const,
  conversation: (id: string) => ['scheduled-messages', 'conversation', id] as const,
  mine: (ws: string) => ['scheduled-messages', 'mine', ws] as const,
};

export function useConversationScheduled(conversationId: string, enabled = true) {
  return useQuery({
    queryKey: scheduledKeys.conversation(conversationId), enabled,
    queryFn: () => api.conversationScheduled(conversationId).then(r => r.items),
    staleTime: 15_000, refetchInterval: 30_000, refetchOnWindowFocus: true,
  });
}

export function useMyScheduled(ws: string | null | undefined) {
  return useQuery({
    queryKey: scheduledKeys.mine(ws ?? ''), enabled: Boolean(ws),
    queryFn: () => api.myScheduled(ws!).then(r => r.items),
    staleTime: 15_000, refetchInterval: 30_000, refetchOnWindowFocus: true,
  });
}

export const refreshScheduled = () => queryClient.invalidateQueries({ queryKey: scheduledKeys.all });

/** Pending ones for this place: the conversation (top-level posts) or one thread. */
export const pendingHere = (items: ScheduledMessage[] | undefined, parentId: string | null | undefined) =>
  (items ?? []).filter(s => s.status === 'scheduled' && (s.parent_id ?? null) === (parentId ?? null));
